// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutShippingSectionStyles } from "@west/Overrides/Widgets/OnePageCheckout/OnePageCheckoutShippingSection";
import defaultFormField from "@west/XDL/PreStyle/formField";
import { css } from "styled-components";

onePageCheckoutShippingSectionStyles.container = {
    gap: 18,
};

onePageCheckoutShippingSectionStyles.headingGridItem = {
    width: 12,
    css: css`
        justify-content: space-between;
        align-items: center;
    `,
};

onePageCheckoutShippingSectionStyles.titleText = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};
onePageCheckoutShippingSectionStyles.heading = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

onePageCheckoutShippingSectionStyles.titleEditLink = {
    typographyProps: {
        size: 14,
    },
};

onePageCheckoutShippingSectionStyles.editLink = {
    typographyProps: {
        size: 14,
        css: css`
            white-space: nowrap;
        `,
    },
};

onePageCheckoutShippingSectionStyles.useShippingAddressGridItem = {
    width: 12,
};
onePageCheckoutShippingSectionStyles.shippingAddressForm = {
    formFields: {
        companyNameText: {
            labelProps: {
                css: css`
                    white-space: nowrap;
                `,
            },
        },
        postalCodeText: {
            labelProps: {
                ...defaultFormField.defaultProps?.labelProps,
                css: css`
                    ${defaultFormField.defaultProps?.labelProps?.css}
                    white-space: nowrap;
                `,
            },
        },
        stateSelect: {
            labelProps: {
                ...defaultFormField.defaultProps?.labelProps,
                css: css`
                    ${defaultFormField.defaultProps?.labelProps?.css}
                    white-space: nowrap;
                `,
            },
        },
    },
};
